import { useState, useEffect } from "react";

const isBrowser = typeof window !== "undefined";

const useReduceMotion = (): boolean => {
  const [ matches, setMatches ] = useState<boolean>(false);
  if (isBrowser) {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)") as MediaQueryList;
    if (mediaQuery.matches !== matches) {
      setMatches(mediaQuery.matches);
    }
    useEffect(() => {
      const handleChange = () => {
        setMatches(mediaQuery.matches);
      };
      handleChange();
      mediaQuery.addEventListener("change", handleChange);
      return () => {
        mediaQuery.removeEventListener("change", handleChange);
      };
    });
  }
  return matches;
};

export default useReduceMotion;